export default __webpack_public_path__ + "static/media/phantom.d8ea856b.png";